// TODO: Task 904718: refactor to use explicit dependency for es6 syntax rather than global variable
/* global Map */
import _ from 'underscore';
import $ from 'jquery';
import UiBlockerView from './view/index';
import containerTemplate from './template/uiBlocker-container.pug';

const registry = new Map();
let timer = null;

function checkTimer() {
  if (!registry.size && timer) {
    window.clearInterval(timer);
    timer = null;
  }
}

function cleanUp() {
  const invalidKey = [];
  registry.forEach((value, key) => {
    if (!value.view.isExisting()) {
      invalidKey.push(key);
      value.view.remove();
    }
  });
  _.each(invalidKey, key => registry.delete(key));
  checkTimer();
}

function handleWindowEvent() {
  cleanUp();
  registry.forEach(entry => entry.view.positionOverlay());
}

function updateText($target, text, callback) {
  const entry = registry.get($target);
  if (entry) {
    entry.view.loadingText = text;
    entry.view.render();
    if (callback) {
      callback();
    }
  }
}

function block($target, loadingText, shouldFocus, delayedLoading, overlayZIndex) {
  const entry = registry.get($target);
  if (entry) {
    entry.counter += 1;
  } else {
    const view = new UiBlockerView({
      $target, loadingText, shouldFocus, overlayZIndex,
    }).render();
    if ($('.blocker-container').length < 1) {
      $('body').append(containerTemplate());
    }

    $('.blocker-container').append(view.el);

    let delayedLoadingTimer = null;
    if (delayedLoading) {
      const {
        time = 10000,
        text = 'It\'s taking a bit longer than expected, but be patient!',
        callback,
      } = delayedLoading;

      delayedLoadingTimer = _.delay(updateText, time, $target, text, callback);
    }

    registry.set($target, { counter: 1, view, delayedLoadingTimer });
    if (registry.size === 1) {
      /* istanbul ignore if  */
      if (timer) {
        throw new Error('Should clear timer to prevent memory leak if no uiblocker exists.');
      }
      timer = window.setInterval(handleWindowEvent.bind(this), 100);
    }
  }
}

function unblock($target) {
  const entry = registry.get($target);
  if (entry) {
    entry.counter -= 1;
    if (entry.counter <= 0) {
      if (entry.delayedLoadingTimer != null) {
        window.clearTimeout(entry.delayedLoadingTimer);
      }
      entry.view.remove();
      registry.delete($target);
    }
  }
  checkTimer();
}

/**
 * Render an ui blocker
 *
 * @param {Object} target - element you want to block, should be DOM element or JQuery object.
 * @param {string} loadingText - the loading text string showing in uiblocker.
 * @param {boolean} shouldFocus - if the uiBlock should take focus on display
 * @param {Obejct} delayedLoading - the object to show the delayedLoading text
 * @param {string} overlayZIndex - the z-index for uiBlock to show on top of the target element.
 * @returns {function} - the unblock function, will be executed when promise resolved/rejected.
 */
export function withUiBlock(target = document.documentElement, loadingText = 'Loading...', shouldFocus = true, delayedLoading, overlayZIndex = 'auto') {
  if (_.isString(target)) {
    throw new Error('Target element should be DOM element or JQuery object.');
  }
  const $target = $(target)[0];
  if (!document.documentElement.contains($target)) {
    return _.noop;
  }
  block($target, loadingText, shouldFocus, delayedLoading, overlayZIndex);
  return () => _.defer(() => { unblock($target); });
}
